// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientBlock_root__32g4Y","header":"PatientBlock_header__1nyW9","label":"PatientBlock_label__3fy4Y","option":"PatientBlock_option__2ilMk"};